import {detailServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = detailServicesPath + "/organizations/compositions/paced-detail-modules";

/**
 * Размещение экземпляра детали модуля в 3D (`PacedDetailModuleDto`).
 * GET `/{id}` — `PacedDetailModuleDto` (incl. `hide`).
 * PUT `/{id}?detailId=` — сохранение (`PacedDetailModuleDto` в body и ответе, incl. `hide`).
 * POST `?detailId=&moduleId=` — создать размещение (`PacedDetailModuleDto` в body и ответе, incl. `hide`).
 * DELETE `/{id}` — снять со сцены.
 * PATCH `/show-or-hide-all-details?moduleId=` — все детали модуля (`boolean` в body).
 * PATCH `/{id}/hide-all-except?moduleId=` — скрыть все, кроме `{id}`.
 */
export default class PacedDetailModulesService {
    static async getById(pacedDetailModuleId) {
        return axios.get(`${restUrl}/${pacedDetailModuleId}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    static async save(detailId, moduleId, data) {
        return axios.post(
            `${restUrl}?detailId=${detailId}&moduleId=${moduleId}`,
            JSON.stringify(data),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
    }

    static async update(pacedDetailModuleId, detailId, data) {
        return axios.put(`${restUrl}/${pacedDetailModuleId}`, JSON.stringify(data), {
            params: {
                detailId,
            },
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    /** PATCH `/{id}/hide` — body: `true` скрыть, `false` показать. */
    static async setHide(pacedDetailModuleId, hide) {
        return axios.patch(`${restUrl}/${pacedDetailModuleId}/hide`, JSON.stringify(Boolean(hide)), {
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    /** DELETE `/{pacedDetailModule.id}` — снять экземпляр со сцены. */
    static async delete(pacedDetailModuleId) {
        return axios.delete(`${restUrl}/${pacedDetailModuleId}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    /** PATCH `/show-or-hide-all-details?moduleId=` — body: `true` скрыть все, `false` показать все. */
    static async showOrHideAllDetails(moduleId, hide) {
        return axios.patch(`${restUrl}/show-or-hide-all-details`, JSON.stringify(Boolean(hide)), {
            params: {moduleId},
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    /**
     * PATCH `/{id}/hide-all-except?moduleId=` — body: `true` скрыть все, кроме `{id}`.
     */
    static async hideAllExcept(pacedDetailModuleId, moduleId, hide = true) {
        return axios.patch(
            `${restUrl}/${pacedDetailModuleId}/hide-all-except`,
            JSON.stringify(Boolean(hide)),
            {
                params: {moduleId},
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
    }
}
